import { ApiUrl } from "../utils/modules";

class CouponService {
  constructor(api) {
    this.api = api;
  }

  create(data) {
    return this.api.post(ApiUrl + "coupon", data);
  }

  getAll() {
    return this.api.get(ApiUrl + "coupon");
  }

  getOne(id) {
    return this.api.get(ApiUrl + `coupon/${id}`);
  }

  update(id, data) {
    return this.api.put(ApiUrl + `coupon/${id}`, data);
  }

  delete(id) {
    return this.api.delete(ApiUrl + `coupon/${id}`);
  }

  verifier(data) {
    return this.api.post(ApiUrl + `coupon/verifier`, data);
  }

  autoApply(params) {
    return this.api.get(ApiUrl + `coupon/auto-apply`, { params });
  }

  incrementerUtilisationCoupon(id) {
    return this.api.post(ApiUrl + `coupon/incrementerUtilisationCoupon`, { id });
  }
}

export default CouponService;
